var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-box"},[_c('video',{attrs:{"src":_vm.videoFullSrc,"autoplay":_vm.autoplay,"loop":_vm.loop,"playsinline":_vm.playsinline,"preload":_vm.preload,"role":"presentation"},domProps:{"muted":_vm.muted}})])
}
var staticRenderFns = []

export { render, staticRenderFns }